import PoliciesModal from './PoliciesModal'
import PoliciesSection from './PoliciesSection'

export { PoliciesModal, PoliciesSection }

